module.exports = __webpack_public_path__ + "img/hand-sparkles.a1e59c71.svg";